module.exports = __webpack_public_path__ + "static/img/SouthPressCoffee@3x.af98351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/SouthPressCoffee@3x.png
// module id = 6/a4
// module chunks = 0